<label>
  <input (change)="changeState($event)" type="checkbox" [checked]="checked" />
  <span class="sliderNew" [ngClass]="checked ? colorClass : 'bg-ccc'">
  </span>
</label>
